import { CreatorLifecycleState } from '../loop/creator-lifecycle';

/** Result of lifecycle evaluation after pipeline processing (no logic, structure only). */
export interface LifecycleEvaluationResult {
  creatorId: string;
  currentState: CreatorLifecycleState;
  evaluatedState: CreatorLifecycleState;
  matchedRuleId: string | null;
  triggered: boolean;
}
